<template>
    <div id="report-new">
        <AppBreadCrumb :paths="[{ title: $t('report.detailReport') }]" :select="true">
            <select id="time-select" v-model="customDateFilter">
                <option value="today">{{ $t("time.today") }}</option>
                <option value="yesterday">{{ $t("time.yesterday") }}</option>
                <option value="current-week">
                    {{ $t("time.currentWeek") }}
                </option>
                <option value="last-week">{{ $t("time.lastWeek") }}</option>
                <option value="current-month">
                    {{ $t("time.currentMonth") }}
                </option>
                <option v-for="(m, i) in getLast11Months()" :key="i" :value="m.date">
                    {{ m.name }}
                </option>
                <option value="custom">
                    {{ $t("time.custom") }}
                </option>
            </select>
        </AppBreadCrumb>

        <b-container class="my-3" fluid>
            <b-row class="mb-3">
                <b-col lg="2" class="d-flex">
                    <div @click="prevDate" class="mr-3 p-1 pageButtons">&lt;</div>
                    <b-form-group class="mb-1">
                        <datetime
                            v-model="startDate"
                            :max-datetime="maxDate"
                            :min-datetime="minDate"
                            :placeholder="$t('message.startDate')"
                            auto
                            input-class="form-control rounded-0"
                            type="datetime"
                        />
                    </b-form-group>
                </b-col>
                <b-col lg="2" class="d-flex">
                    <b-form-group class="mb-1">
                        <datetime
                            v-model="endDate"
                            :max-datetime="maxDate"
                            :min-datetime="minDate"
                            :placeholder="$t('message.endDate')"
                            auto
                            input-class="form-control rounded-0"
                            type="datetime"
                        />
                    </b-form-group>
                    <div @click="nextDate" class="ml-3 p-1 pageButtons">&gt;</div>
                </b-col>
                <b-col lg="6">
                    <div style="display: grid; gap: 5px">
                        <div class="d-flex">
                            <md-chip v-if="selectedUsers.length === 0" class="md-primary">
                                {{ $t("message.allRepresentatives") }}
                            </md-chip>
                            <md-chip
                                v-for="user in getSelectedUsers()"
                                :key="user._id"
                                class="md-primary"
                                md-deletable
                                @md-delete="removeUser(user._id)"
                            >
                                {{ capitalize(user.name) }}
                            </md-chip>
                            <md-chip
                                v-if="
                                    !autoCompleteShow &&
                                    usersFilter.data.filter((x) => !selectedUsers.includes(x._id)).length
                                "
                                class="md-accent"
                                md-clickable
                                @click="openAutoComplete"
                            >
                                + {{ $t("message.addRepresentative") }}
                            </md-chip>
                            <md-autocomplete
                                v-if="autoCompleteShow"
                                v-model="autoComploteValue"
                                :md-fuzzy-search="true"
                                :md-open-on-focus="true"
                                :md-options="usersFilter.data.filter((x) => !selectedUsers.includes(x._id))"
                                autofocus
                                class="ml-3"
                                md-input-id="acUsers"
                                @md-selected="autoCompleteSelected"
                            >
                                <label>{{ $t("message.selectRep") }}</label>

                                <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                                    <div style="display: flex; align-items: center; font-size: 16px">
                                        <Avatar :size="40" :username="item.name" class="mr-2" style="color: white" />
                                        <md-highlight-text :md-term="term">
                                            {{ capitalize(item.name) }}
                                        </md-highlight-text>
                                    </div>
                                </template>

                                <template slot="md-autocomplete-empty" slot-scope="{ term }">
                                    {{ $t("message.noRePresentativeFound") }}
                                </template>
                            </md-autocomplete>
                        </div>
                        <div class="d-flex">
                            <md-chip
                                v-for="channel in getSelectedChannels()"
                                :key="channel._id"
                                class="md-primary"
                                md-deletable
                                @md-delete="removeChannel(channel._id)"
                            >
                                {{ channel.name }}
                            </md-chip>
                            <md-chip v-if="selectedChannels.length === 0" class="md-primary"> Bütün Kanallar </md-chip>
                            <md-chip
                                class="md-accent"
                                style="background: #3f8646 !important"
                                md-clickable
                                @click="openAutoCompleteChannel"
                            >
                                + Kanal Ekle
                            </md-chip>
                            <md-autocomplete
                                v-if="autoCompleteShowChannel"
                                v-model="channelName"
                                :md-fuzzy-search="true"
                                :md-open-on-focus="true"
                                :md-options="channels.filter((x) => !selectedChannels.includes(x._id))"
                                class="ml-3"
                                md-input-id="acChannels"
                                @md-selected="autoCompleteSelectedChannel"
                            >
                                <label>Bir kanal seçin</label>

                                <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                                    <div style="display: flex; align-items: center; font-size: 16px">
                                        <md-highlight-text :md-term="term">
                                            {{ item.name }}
                                        </md-highlight-text>
                                    </div>
                                </template>

                                <template slot="md-autocomplete-empty" slot-scope="{ term }">
                                    Kanal Bulunamadı
                                </template>
                            </md-autocomplete>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div v-if="!loading">
                <b-row>
                    <b-col lg="4">
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 0)">
                            <p class="label">Overall</p>
                            <p class="value"></p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 1)">
                            <p class="label">
                                {{ $t("message.distConversation") }}
                            </p>
                            <p class="value"></p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 2)">
                            <p class="label">
                                {{ $t("message.totalConnected") }}
                            </p>
                            <p class="value">
                                {{ statistics.totalChatCount }}
                            </p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 4)">
                            <p class="label">Channel Overall</p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 5)">
                            <p class="label">
                                {{ $t("message.agentActivities") }}
                            </p>
                            <p class="value"></p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 6)">
                            <p class="label">{{ $t("message.videoCallDist") }}</p>
                            <p class="value"></p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 7)">
                            <p class="label">
                                {{
                                    $t("message.avgRating", {
                                        count: totalRateCount(),
                                        point: statistics.avgRate,
                                    })
                                }}
                            </p>
                            <p class="value">
                                <a-rate :value="statistics.avgRate" allow-half disabled style="font-size: 12px" />
                            </p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 8)">
                            <p class="label">{{ $t("message.workTime") }}</p>
                            <p class="value">
                                {{ statistics.workInfo.totalWorkTime | twoUnitTimeFilter($i18n.locale) }}
                            </p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 9)">
                            <p class="label">
                                {{ $t("message.totalBreakNum") }}
                            </p>
                            <p class="value">
                                {{ statistics.breakInfo.totalBreakCount }}
                            </p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 10)">
                            <p class="label">
                                {{ $t("message.personalRating") }}
                            </p>
                            <p class="value"></p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 11)">
                            <p class="label">
                                {{ $t("message.avgFirstMessageTime") }}
                            </p>
                            <p class="value">
                                {{ statistics.avgFirstMessageTime | twoUnitTimeFilter($i18n.locale) }}
                            </p>
                        </div>
                        <div class="box yes-hover" @click="updateQueryParams('tabIndex', 12)">
                            <p class="label">
                                {{ $t("message.averageConTime") }}
                            </p>
                            <p class="value">
                                {{ statistics.avgChatDuration | twoUnitTimeFilter($i18n.locale) }}
                            </p>
                        </div>
                        <div class="box no-shadow">
                            <p class="label">
                                {{ $t("message.totalWhatsappChatCount") }}
                            </p>
                            <p class="value">
                                {{ statistics.totalWhatsappChatCount }}
                            </p>
                        </div>
                        <div class="box no-shadow">
                            <p class="label">{{ $t("message.chatBotEndStatics") }}</p>
                            <p v-if="statistics.totalChatbotConversation > 0" class="value">
                                %{{ calculateChatbotRate }}
                            </p>
                            <p v-else class="value">-</p>
                        </div>
                        <div class="box no-shadow">
                            <p class="label">{{ $t("message.missedChat") }}</p>
                            <p class="value">{{ statistics.missedChat }}</p>
                        </div>
                        <div class="box no-shadow">
                            <p class="label">
                                {{ $t("message.closedChatCount") }}
                            </p>
                            <p class="value">{{ statistics.destroyedCount }}</p>
                        </div>
                        <div class="box no-shadow">
                            <p class="label">
                                {{ $t("message.totalBreakTime") }}
                            </p>
                            <p class="value">
                                {{ statistics.breakInfo.totalBreakTime | twoUnitTimeFilter($i18n.locale) }}
                            </p>
                        </div>
                        <div class="box no-shadow">
                            <p class="label">
                                {{ $t("message.shortestConTime") }}
                            </p>
                            <p class="value">
                                {{ statistics.minChatDuration | twoUnitTimeFilter($i18n.locale) }}
                            </p>
                        </div>
                        <div class="box no-shadow">
                            <p class="label">
                                {{ $t("message.longestConTime") }}
                            </p>
                            <p class="value">
                                {{ statistics.maxChatDuration | twoUnitTimeFilter($i18n.locale) }}
                            </p>
                        </div>
                    </b-col>
                    <b-col lg="8">
                        <div v-show="tabIndex === 0" class="custom-card-repor">
                            <div style="display: grid; gap: 10px; height: 100vh; overflow: scroll">
                                <div v-show="tabIndex === 0" class="custom-card-report-overall">
                                    <Overall :graph-data="statistics ? statistics.overall : null" :loading="loading" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="display: flex; flex-direction: row; margin-right: 10px; margin-bottom: 10px">
                                <div
                                    v-show="tabIndex === 1"
                                    class="custom-card-report"
                                    style="width: 500px; height: 500px; margin-right: 10px; padding: 10px"
                                >
                                    <h5>{{ $t("message.distConversation") }}</h5>
                                    <ECharts
                                        v-if="Object.keys(statistics.userChatHistogram).length"
                                        id="chart-2"
                                        ref="chart"
                                        :option="pie"
                                        style="height: calc(70vh - 200px)"
                                    />
                                    <ChartNotFound :title="$t('message.dataNotFound')" v-else />
                                </div>
                                <div
                                    v-show="tabIndex === 1"
                                    class="custom-card-report"
                                    style="width: 500px; height: 500px; margin-right: 10px"
                                >
                                    <h5>{{ $t("message.distChatbotAgent") }}</h5>
                                    <ECharts
                                        v-if="
                                            Object.values(statistics.pies.distributionPerChannel).reduce(
                                                (a, b) => a + b,
                                                0
                                            )
                                        "
                                        id="chart-2"
                                        ref="chart"
                                        :option="calculateDistributionPerProvider()"
                                        style="height: calc(70vh - 200px)"
                                    />
                                    <ChartNotFound :title="$t('message.dataNotFound')" v-else />
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: row; margin-right: 10px; margin-bottom: 10px">
                                <div
                                    v-show="tabIndex === 1"
                                    class="custom-card-report"
                                    style="width: 500px; height: 500px; margin-right: 10px"
                                >
                                    <h5>{{ $t("message.distFugitive") }}</h5>
                                    <ECharts
                                        v-if="
                                            Object.values(statistics.pies.distributionPerHandling).reduce(
                                                (a, b) => a + b,
                                                0
                                            )
                                        "
                                        id="chart-2"
                                        ref="chart"
                                        :option="calculateDistributionPerProviderSpeech()"
                                        style="height: calc(70vh - 200px)"
                                    />
                                    <ChartNotFound :title="$t('message.dataNotFound')" v-else />
                                </div>
                                <div
                                    v-show="tabIndex === 1"
                                    class="custom-card-report"
                                    style="width: 500px; height: 500px; margin-right: 10px"
                                >
                                    <h5>{{ $t("message.distAgent") }}</h5>
                                    <ECharts
                                        v-if="
                                            Object.values(statistics.pies.distributionPerType).reduce(
                                                (a, b) => a + b,
                                                0
                                            )
                                        "
                                        id="chart-2"
                                        ref="chart"
                                        :option="calculateDistributionPerProciderChat()"
                                        style="height: calc(70vh - 200px)"
                                    />
                                    <ChartNotFound :title="$t('message.dataNotFound')" v-else />
                                </div>
                            </div>
                        </div>
                        <div v-show="tabIndex === 2" class="custom-card-report">
                            <h5>{{ $t("message.statsByTime") }}</h5>
                            <ECharts id="chart-1" ref="chart" :option="bar" style="height: calc(100vh - 200px)" />
                        </div>
                        <div v-show="tabIndex === 4" class="custom-card-report">
                            <h5>Channel Overall</h5>
                            <ChannelOverall
                                :graph-data="statistics ? statistics.channelOverall : null"
                                :loading="loading"
                            />
                        </div>
                        <div
                            v-if="tabIndex === 5"
                            class="custom-card-report h-100"
                            :key="getInitialStartDateForAgentActivities()"
                        >
                            <h5>{{ $t("message.agentActivities") }}</h5>
                            <DailyAgentActivities
                                :selected-users="selectedUsers"
                                :initial-start-date="getInitialStartDateForAgentActivities()"
                                :key="getInitialStartDateForAgentActivities()"
                            />
                        </div>
                        <div v-show="tabIndex === 6" class="custom-card-report">
                            <h5>{{ $t("message.videoCallDist") }}</h5>
                            <ECharts
                                v-if="Object.keys(statistics.userChatHistogram).length"
                                id="chart-20"
                                ref="chart"
                                :option="videoCallPie"
                                style="height: calc(100vh - 200px)"
                            />
                            <ChartNotFound v-else :title="$t('message.dataNotFound')"></ChartNotFound>
                        </div>
                        <div v-show="tabIndex === 7" class="custom-card-report">
                            <h5>{{ $t("message.rateDist") }}</h5>
                            <ECharts
                                v-if="Object.keys(statistics.ratingHistogram).length"
                                id="chart-3"
                                ref="chart"
                                :option="point"
                                style="height: calc(100vh - 200px)"
                            />
                            <ChartNotFound v-else :title="$t('message.dataNotFound')"></ChartNotFound>
                        </div>
                        <div v-show="tabIndex === 8" class="custom-card-report">
                            <div v-if="['today', 'yesterday'].includes(customDateFilter)">
                                <ECharts :option="barY" style="height: calc(100vh - 100px)" />
                            </div>

                            <div v-else class="moreThanDay">
                                <h5>{{ calendarTitle }}</h5>
                                <b-form-group class="mb-1" style="align-self: flex-end">
                                    <b-form-select v-model="selectedCalendarUser" class="mb-3">
                                        <option v-for="user in calendarUsers" :key="user._id" :value="user._id">
                                            {{ user.name }}
                                        </option>
                                    </b-form-select>
                                </b-form-group>
                                <ECharts
                                    id="calendar"
                                    ref="calendar"
                                    :option="calendar"
                                    style="height: calc(100vh - 100px)"
                                />
                            </div>
                        </div>
                        <div v-show="tabIndex === 9" class="custom-card-report">
                            <h5>{{ $t("message.breaksByTime") }}</h5>
                            <ECharts id="chart-4" ref="chart" :option="barBreak" style="height: calc(100vh - 200px)" />
                        </div>
                        <div v-show="tabIndex === 10" class="custom-card-report">
                            <h5>{{ $t("message.personalRating") }}</h5>
                            <ECharts
                                v-if="Object.keys(statistics.userRateHistogram).length"
                                id="chart-5"
                                ref="chart"
                                :option="pieBorder"
                                style="height: calc(100vh - 200px)"
                            />
                            <ChartNotFound v-else :title="$t('message.dataNotFound')"></ChartNotFound>
                        </div>
                        <div v-show="tabIndex === 11" class="custom-card-report">
                            <h5>{{ $t("message.personalFirstMsg") }}</h5>
                            <ECharts
                                v-if="Object.keys(statistics.userFirstMsgHistogram).length"
                                id="chart-6"
                                ref="chart"
                                :option="line"
                                style="height: calc(100vh - 200px)"
                            />
                            <ChartNotFound v-else :title="$t('message.dataNotFound')"></ChartNotFound>
                        </div>
                        <div v-show="tabIndex === 12" class="custom-card-report">
                            <h5>{{ $t("message.averageConTime") }}</h5>
                            <ECharts
                                v-if="Object.keys(statistics.userAvgChatDuration).length"
                                id="chart-7"
                                ref="chart"
                                :option="userAvgChatDuration"
                                style="height: calc(100vh - 200px)"
                            />
                            <ChartNotFound v-else :title="$t('message.dataNotFound')"></ChartNotFound>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <md-progress-spinner
                v-else
                :md-diameter="100"
                :md-stroke="10"
                md-mode="indeterminate"
                style="position: absolute; left: 45%; top: 50%"
            />
        </b-container>
    </div>
</template>

<script>
import Vue from "vue";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import bar from "./data/bar";
import barBreak from "./data/barBreak";
import barY from "./data/barY";
import pie from "./data/pie";
import pieBorder from "./data/pieBorder";
import point from "./data/point";
import calendar, { getPieSeries } from "./data/calendar";
import moment from "moment";
import { getUsers } from "../../api/user";
import { getStatistics } from "../../api/statistics";
import * as echarts from "echarts";
import { createComponent, plugin } from "echarts-for-vue";
import Avatar from "vue-avatar";
import { log2 } from "../../utils/log2";
import { mapState, mapActions } from "vuex";
import line from "./data/line";
import AgentActivityBar from "../../components/charts/AgentActivityBar";
import DailyAgentActivities from "../../components/charts/DailyAgentActivities";
import _ from "lodash";
import ChartNotFound from "../Pages/Chatbot/components/ChartNotFound.vue";
import Overall from "./overall/Overall.vue";
import ChannelOverall from "./overall/ChannelOverall.vue";

Vue.use(plugin, { echarts });

const defaultStartDate = moment().startOf("day").toISOString();
const defaultEndDate = moment().endOf("day").toISOString();
const log = log2("Reports");

export default {
    name: "Reports",
    components: {
        ChannelOverall,
        ECharts: createComponent({ echarts }),
        Avatar,
        AppBreadCrumb,
        AgentActivityBar,
        DailyAgentActivities,
        ChartNotFound,
        Overall,
    },
    data() {
        return {
            channelName: "",
            userAvgChatDuration: null,
            line: null,
            wpBar: null,
            bar: null,
            barBreak: null,
            pie: null,
            videoCallPie: null,
            pieBorder: null,
            point: point(),
            calendar: null,
            barY: null,
            selectedCalendarUser: null,
            tabIndex: isNaN(this.$route.query.tabIndex) ? 0 : parseInt(this.$route.query.tabIndex),
            customDateFilter: this.$route.query.customDate ? this.$route.query.customDate : "today",
            selectedUsers: this.$route.query.selectedUsers ? this.$route.query.selectedUsers.split(",") : [],
            selectedChannels: this.$route.query.channels ? this.$route.query.channels.split(",") : [],
            startDate: this.$route.query.allTime
                ? null
                : this.$route.query.startDate
                ? moment(parseInt(this.$route.query.startDate)).toISOString()
                : defaultStartDate,
            endDate: this.$route.query.allTime
                ? null
                : this.$route.query.endDate
                ? moment(parseInt(this.$route.query.endDate)).toISOString()
                : defaultEndDate,
            maxDate: moment().toISOString(),
            usersFilter: {
                data: [],
            },
            channelsFilter: {
                data: [],
            },
            autoComploteValue: "",
            statistics: {},
            loading: true,
            autoCompleteShow: false,
            autoCompleteShowChannel: false,
            calendarTitle: "",
            graphData: null,
        };
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
        }),
        calculateDistributionPerProvider() {
            const labels = {
                web: this.$t("message.distWeb"),
                whatsapp: this.$t("message.distWhatsapp"),
                telegram: this.$t("message.distTelegram"),
                instagram: this.$t("message.distInstagram"),
            };
            const data = _.get(this.statistics, "pies.distributionPerChannel");
            if (!data) return {};
            const result = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: 10,
                    data: Object.keys(data)
                        .filter((key) => data[key] > 0)
                        .map((key) => labels[key]),
                },
                color: ["#e55699", "#4e98ef", "#4dc247", "#ef7820"],
                series: [
                    {
                        name: "Data",
                        type: "pie",
                        radius: "50%",
                        data: Object.keys(data)
                            .filter((key) => data[key] > 0)
                            .map((key) => ({
                                value: data[key],
                                name: labels[key],
                            })),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };

            return result;
        },
        calculateDistributionPerProviderSpeech() {
            const labels = {
                handled: this.$t("message.distHandled"),
                missed: this.$t("message.distMissed"),
            };
            const data = _.get(this.statistics, "pies.distributionPerHandling");
            if (!data) return {};
            const result = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: 10,
                    data: Object.keys(data)
                        .filter((key) => data[key] > 0)
                        .map((key) => labels[key]),
                },
                color: ["#4e98ef", "#4dc247"],
                series: [
                    {
                        name: "Data",
                        type: "pie",
                        radius: "50%",
                        data: Object.keys(data)
                            .filter((key) => data[key] > 0)
                            .map((key) => ({
                                value: data[key],
                                name: labels[key],
                            })),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
            return result;
        },
        calculateDistributionPerProciderChat() {
            const labels = {
                chatbot: this.$t("message.distChatbot"),
                live: this.$t("message.distLive"),
                complex: this.$t("message.distComplex"),
            };
            const data = _.get(this.statistics, "pies.distributionPerType");
            if (!data) return {};
            const result = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: 10,
                    data: Object.keys(data)
                        .filter((key) => data[key] > 0)
                        .map((key) => labels[key]),
                },
                color: ["#e55699", "#ef7820", "#a97f69"],
                series: [
                    {
                        name: "Data",
                        type: "pie",
                        radius: "50%",
                        data: Object.keys(data)
                            .filter((key) => data[key] > 0)
                            .map((key) => ({
                                value: data[key],
                                name: labels[key],
                            })),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };

            return result;
        },
        getLast11Months() {
            let months = [];
            for (let i = 1; i < 12; i++) {
                let date = moment().subtract(i, "months");
                months.push({
                    name: date.format("MMMM YYYY"),
                    date: {
                        start: date.utc().startOf("month").toISOString(),
                        end: date.utc().endOf("month").toISOString(),
                    },
                });
            }

            return months;
        },
        capitalize(text = "") {
            return _.startCase(text.toLowerCase().trim());
        },
        openAutoComplete() {
            this.autoCompleteShow = true;
            setTimeout(() => {
                const elem = document.getElementById("acUsers");
                if (elem) elem.click();
            }, 200);
        },
        openAutoCompleteChannel() {
            this.autoCompleteShowChannel = true;
            setTimeout(() => {
                const elem = document.getElementById("acChannels");
                if (elem) elem.click();
            }, 200);
        },
        removeUser(id) {
            log("removeUser", {
                users: this.selectedUsers,
                after: this.selectedUsers.filter((x) => x !== id),
            });
            this.selectedUsers = this.selectedUsers.filter((x) => x !== id);
        },
        removeChannel(id) {
            log("removeChannel", {
                channels: this.selectedChannels,
                after: this.selectedChannels.filter((x) => x !== id),
            });
            this.selectedChannels = this.selectedChannels.filter((x) => x !== id);
        },
        getSelectedUsers() {
            return this.usersFilter.data
                ? this.selectedUsers
                      .map((id) => this.usersFilter.data.find((x) => x._id === id))
                      .filter((x) => x != null)
                : [];
        },
        getSelectedChannels() {
            return this.channels.length > 0
                ? this.selectedChannels.map((id) => this.channels.find((x) => x._id === id)).filter((x) => x != null)
                : [];
        },
        autoCompleteSelected(user) {
            this.selectedUsers.push(user._id);
            this.autoCompleteShow = false;
            this.autoComploteValue = "";
        },
        autoCompleteSelectedChannel(channel) {
            this.selectedChannels.push(channel._id);
            this.autoCompleteShowChannel = false;
            this.channelName = "";
        },
        setCustomDateFilter(filter) {
            log("setCustomDateFilter", filter);
            if (filter === "today" || filter === "custom") {
                this.startDate = moment().startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "yesterday") {
                this.startDate = moment().subtract(1, "days").startOf("day").toISOString();
                this.endDate = moment().subtract(1, "days").endOf("day").toISOString();
            } else if (filter === "current-week") {
                this.startDate = moment().startOf("week").startOf("day").toISOString();
                this.endDate = moment().endOf("week").endOf("day").toISOString();
            } else if (filter === "last-week") {
                this.startDate = moment().subtract(1, "week").startOf("week").startOf("day").toISOString();
                this.endDate = moment().subtract(1, "week").endOf("week").endOf("day").toISOString();
            } else if (filter === "current-month") {
                this.startDate = moment().startOf("month").startOf("day").toISOString();
                this.endDate = moment().endOf("month").endOf("day").toISOString();
            } else if (filter === "last-month") {
                this.startDate = moment().subtract(1, "month").startOf("month").startOf("day").toISOString();
                this.endDate = moment().subtract(1, "month").endOf("month").endOf("day").toISOString();
            } else if (typeof filter === "object") {
                this.startDate = filter.start;
                this.endDate = filter.end;
            } else {
                this.startDate = null;
                this.endDate = null;
            }
        },
        updateQueryParams(key, value) {
            if (key === "tabIndex") {
                this.tabIndex = value;
                if (value === 5) this.renderCalendar();
            }
            if (value === "" || value == null) {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({ query });
            } else {
                let { query } = this.$route;
                this.$router.replace({
                    query: { ...query, [key]: encodeURI(value) },
                });
            }
        },
        renderLineChatDuration(data) {
            let users = Object.keys(data)
                .filter((userId) => this.selectedUsers.includes(userId) || !this.selectedUsers.length)
                .map((userId) => this.usersFilter.data.find((x) => x._id === userId))
                .filter((x) => x != null);
            let userFirstMsgHistograms = users.map((user) => ({
                name: `${user.name}`,
                value: (data[user._id].time / data[user._id].count).toFixed(2),
            }));
            this.userAvgChatDuration = line(userFirstMsgHistograms);
        },
        renderLine(data) {
            let users = Object.keys(data)
                .filter((userId) => this.selectedUsers.includes(userId) || !this.selectedUsers.length)
                .map((userId) => this.usersFilter.data.find((x) => x._id === userId))
                .filter((x) => x != null);
            let userFirstMsgHistograms = users.map((user) => ({
                name: `${user.name}`,
                value: parseFloat((data[user._id].time / data[user._id].count).toFixed(2)),
            }));
            const sortedUserFirstMsgHistograms = _.sortBy(userFirstMsgHistograms, "value");
            this.line = line(sortedUserFirstMsgHistograms);
        },
        renderBar(data) {
            log("renderBar", this.usersFilter);
            let labels = Object.keys(data).sort((s, e) => {
                const date1 = moment(s).toDate().getTime();
                const date2 = moment(e).toDate().getTime();
                if (date1 === date2) return 0;
                if (date1 > date2) return 1;
                if (date1 < date2) return -1;
            });
            let max = 0;
            max = _.max(
                labels
                    .map((label) =>
                        data[label].filter((d) =>
                            this.usersFilter.data.find((x) => x._id === d.userId) ? true : false
                        )
                    )
                    .map((xs) => _.sumBy(xs, (x) => x.chatCount || 0))
            );

            let userChatCounts = labels.reduce((acc, label) => {
                data[label]
                    .map((x) => x.userId)
                    .forEach((userId) => {
                        const user = this.usersFilter.data.find((x) => x._id === userId);
                        if (user && (!this.selectedUsers.length || this.selectedUsers.includes(userId))) {
                            const name = user ? user.name : userId;
                            acc[name] = labels.map((l) => {
                                let findUser = data[l].find((x) => x.userId === userId);
                                return findUser ? findUser.chatCount : null;
                            });
                        }
                    });
                return acc;
            }, {});
            log.debug("period", this.statistics.period);
            if (this.statistics.period === "hour") {
                labels = labels.map((x) => moment(x).format("DD/MM HH:mm"));
            } else {
                labels = labels.map((x) => moment(x).format("DD/MM/YYYY"));
            }
            this.bar = bar(labels, userChatCounts, max);
        },
        renderBarBreak(data) {
            if (!data) return;
            let labels = Object.keys(data).sort((s, e) => {
                const date1 = moment(s).toDate().getTime();
                const date2 = moment(e).toDate().getTime();
                if (date1 === date2) return 0;
                if (date1 > date2) return 1;
                if (date1 < date2) return -1;
            });
            let max = 0;
            max = _.max(
                labels
                    .map((label) => data[label].filter((d) => this.usersFilter.data.find((x) => x._id === d.userId)))
                    .map((xs) => _.sumBy(xs, (x) => x.count || 0))
            );

            let userBreakCounts = labels.reduce((acc, label) => {
                data[label]
                    .map((x) => x.userId)
                    .forEach((userId) => {
                        const user = this.usersFilter.data.find((x) => x._id === userId);
                        if (user && (!this.selectedUsers.length || this.selectedUsers.includes(userId))) {
                            const name = user ? user.name : userId;
                            acc[name] = labels.map((l) => {
                                let findUser = data[l].find((x) => x.userId === userId);
                                return findUser ? findUser.count : null;
                            });
                        }
                    });
                return acc;
            }, {});
            if (this.statistics.period === "hour") {
                labels = labels.map((x) => moment(x).format("DD/MM HH:mm"));
            } else {
                labels = labels.map((x) => moment(x).format("DD/MM/YYYY"));
            }
            this.barBreak = barBreak(labels, userBreakCounts, max);
        },
        renderBarBreakForDay(data) {
            if (!data) return;
            let userActions = Object.keys(data).reduce((acc, l) => [...acc, ...data[l]], []);
            userActions = _.groupBy(userActions, (x) => x.userId);
            userActions = Object.keys(userActions).reduce((acc, u) => {
                let maybeUser = this.usersFilter.data.find((x) => x._id === u);
                acc[maybeUser ? maybeUser.name : u] = _.sumBy(userActions[u], (x) => x.count);
                return acc;
            }, {});
            let labels = Object.keys(userActions);
            let max = _.max(labels.map((x) => userActions[x]));
            this.barBreak = barBreak(labels, userActions, max, true);
        },
        renderBarY(data) {
            let userInfos = data[Object.keys(data)[0]] || [];

            let series = userInfos.reduce(
                (acc, cur) => {
                    Object.keys(cur.status).forEach((x) => {
                        acc[x].push(cur.status[x]);
                    });
                    return acc;
                },
                {
                    online: [],
                    away: [],
                    busy: [],
                    offline: [],
                    disconnected: [],
                }
            );
            series = Object.keys(series).reduce((acc, cur) => {
                acc.push({
                    name: cur.charAt(0).toUpperCase() + cur.substr(1),
                    data: series[cur],
                    color:
                        cur === "online"
                            ? "rgb(27, 197, 189)"
                            : cur === "away"
                            ? "rgb(54, 153, 255)"
                            : cur === "busy"
                            ? "rgb(255, 168, 0)"
                            : cur === "offline"
                            ? "rgb(246, 78, 96)"
                            : "rgb(131,131,131)",
                });
                return acc;
            }, []);

            let labels = userInfos
                .map((x) => this.usersFilter.data.find((user) => user._id === x.userId))
                .filter((x) => !!x)
                .map((x) => x.name);

            log("barY series", {
                series,
            });
            this.barY = barY(labels, series);
        },
        renderPie(data) {
            let users = Object.keys(data)
                .filter((userId) => this.selectedUsers.includes(userId) || !this.selectedUsers.length)
                .map((userId) => this.usersFilter.data.find((x) => x._id === userId))
                .filter((x) => x != null);
            let userHistograms = users.map((user) => ({
                name: `${user.name} (${data[user._id]})`,
                value: data[user._id],
            }));
            let sortedUserHistograms = _.sortBy(
                userHistograms.map((x) =>
                    Object.fromEntries(
                        Object.entries(x).map(([key, value]) => [
                            key,
                            typeof value == "string" ? value.toLowerCase() : value,
                        ])
                    )
                ),
                ["value"]
            ).reverse();
            log("pie 1", { s: sortedUserHistograms, u: userHistograms });
            this.pie = pie(sortedUserHistograms);
        },
        renderVideoCallPie(data) {
            let users = Object.keys(data)
                .filter((userId) => this.selectedUsers.includes(userId) || !this.selectedUsers.length)
                .map((userId) => this.usersFilter.data.find((x) => x._id === userId))
                .filter((x) => x != null);
            let userHistograms = users.map((user) => ({
                name: `${user.name} (${data[user._id]})`,
                value: data[user._id],
            }));
            this.videoCallPie = pie(userHistograms);
        },
        renderPieBorder(data) {
            let users = Object.keys(data)
                .filter((userId) => this.selectedUsers.includes(userId) || !this.selectedUsers.length)
                .map((userId) => this.usersFilter.data.find((x) => x._id === userId))
                .filter((x) => x != null);
            let userRateHistograms = users.map((user) => ({
                name: `${user.name} (${Math.round(data[user._id].rate / data[user._id].count)})`,
                value: Math.round(data[user._id].rate / data[user._id].count),
            }));
            this.pieBorder = pieBorder(userRateHistograms);
        },
        renderPoint(data) {
            let keys = Object.keys(data);
            let ratingHistogram = keys.map((key) => ({
                name: `${"⭐".repeat(parseInt(key))} (${data[key]})`,
                value: data[key],
            }));
            this.point = point(ratingHistogram);
        },
        renderCalendar() {
            log.debug("renderCalendar");
            const calendarUsers = this.calendarUsers;
            if (calendarUsers.length) {
                let data = this.statistics.calendar;
                let userId = (this.selectedCalendarUser || "").toString();
                data = Object.keys(data).map((bucketTime) => {
                    let maybeUser = data[bucketTime].find((y) => y.userId === userId);

                    return [moment(bucketTime).format("YYYY-MM-DD"), maybeUser ? maybeUser.status : { offline: 24 }];
                });

                setTimeout(() => {
                    let calendar2 = document.getElementById("calendar");
                    if (calendar2) {
                        let myChart = echarts.init(calendar2);
                        getPieSeries(data, myChart);
                    }
                }, 100);
            }
        },
        totalRateCount() {
            return _.sum(Object.keys(this.statistics.ratingHistogram).map((x) => this.statistics.ratingHistogram[x]));
        },
        beforeCalendar() {
            const buckets = Object.keys(this.statistics.calendar);
            const scatterData = Object.keys(this.statistics.calendar).map((x) => [
                moment(x).format("YYYY-MM-DD"),
                Math.ceil(Math.random() * 100),
            ]);
            const ranges =
                buckets.length > 32
                    ? [moment(_.head(buckets)).format("YYYY-MM-DD"), moment(_.last(buckets)).format("YYYY-MM-DD")]
                    : [moment(_.head(buckets)).format("YYYY-MM")];

            this.updateCalendarTitle();
            this.calendar = calendar(ranges, scatterData);
        },
        getStatistics: _.debounce(async function () {
            this.loading = true;
            const req = {
                startDate: moment(this.startDate).toISOString(),
                endDate: moment(this.endDate).toISOString(),
                users: this.selectedUsers,
                channels: this.selectedChannels,
            };
            log("statistic request", {
                req,
            });
            let { data } = await getStatistics(req);
            this.statistics = data;
            if (this.customDateFilter === "custom") {
                this.updateQueryParams("startDate", moment(this.startDate).toISOString());
                this.updateQueryParams("endDate", moment(this.endDate).toISOString());
            } else {
                this.updateQueryParams("startDate", null);
                this.updateQueryParams("endDate", null);
            }
            if (typeof this.customDateFilter === "string") {
                this.updateQueryParams("customDate", this.customDateFilter);
            }

            this.updateQueryParams("tabIndex", this.tabIndex);
            this.updateQueryParams("selectedUsers", this.selectedUsers.length ? this.selectedUsers : null);
            this.updateQueryParams("channels", this.selectedChannels.length ? this.selectedChannels : null);
            const calendarUsers = this.calendarUsers;
            if (calendarUsers.length) this.selectedCalendarUser = calendarUsers[0]._id;
            else this.selectedCalendarUser = null;
            if (data.period === "hour") this.renderBarBreakForDay(data.breakInfo.breakBuckets);
            else this.renderBarBreak(data.breakInfo.breakBuckets);
            this.renderLine(data.userFirstMsgHistogram);
            this.renderLineChatDuration(data.userAvgChatDuration);
            this.renderBar(data.userChatTimeLine);
            this.renderBarY(data.calendar);
            this.renderPie(data.userChatHistogram);
            this.renderVideoCallPie(data.userVideoCallHistogram);
            this.renderPieBorder(data.userRateHistogram);
            this.renderPoint(data.ratingHistogram);
            this.beforeCalendar();
            this.loading = false;
        }, 200),
        getInitialStartDateForAgentActivities() {
            return moment(this.startDate).startOf("day").valueOf();
        },
        updateCalendarTitle() {
            const calendarUsers = this.calendarUsers;
            const buckets = Object.keys(this.statistics.calendar);

            const maybeSelectedCalendarUserName = this.selectedCalendarUser
                ? calendarUsers.find((x) => x._id === this.selectedCalendarUser)
                    ? calendarUsers.find((x) => x._id === this.selectedCalendarUser).name
                    : undefined
                : undefined;
            let title = "";
            if (maybeSelectedCalendarUserName) {
                const name = _.startCase(maybeSelectedCalendarUserName.trim().toLowerCase());
                const sDate = moment(_.head(buckets)).format("D MMMM");
                const eDate = moment(_.last(buckets)).format("D MMMM");
                if (sDate !== eDate) {
                    //title = `${name} Adlı Kullanıcının ${sDate} - ${eDate} Arası Çalışma Takvimi`
                    title = this.$t("message.workSchedule", {
                        name,
                        sDate,
                        eDate,
                    });
                } else {
                    //title = `${name} Adlı Kullanıcının ${sDate} Günü  Çalışma Takvimi`
                    title = this.$t("message.workScheduleOneDay", {
                        name,
                        sDate,
                    });
                }
            }
            this.calendarTitle = title;
        },
        nextDate() {
            let period =
                this.customDateFilter === "today" ||
                this.customDateFilter === "yesterday" ||
                this.customDateFilter === "custom"
                    ? "days"
                    : this.customDateFilter === "current-week" || this.customDateFilter === "last-week"
                    ? "week"
                    : "month";

            this.startDate = moment(this.startDate).add(1, period).toISOString();
            this.endDate = moment(this.endDate).add(1, period).toISOString();
            this.getStatistics();
        },
        prevDate() {
            let period =
                this.customDateFilter === "today" ||
                this.customDateFilter === "yesterday" ||
                this.customDateFilter === "custom"
                    ? "days"
                    : this.customDateFilter === "current-week" || this.customDateFilter === "last-week"
                    ? "week"
                    : "month";

            this.startDate = moment(this.startDate).subtract(1, period).toISOString();
            this.endDate = moment(this.endDate).subtract(1, period).toISOString();
            this.getStatistics();
        },
    },
    mounted() {
        moment.locale(this.$i18n.locale);
        if (this.customDateFilter !== "custom") this.setCustomDateFilter(this.customDateFilter);
        getUsers({ perPage: 1000, page: 1 }).then((response) => {
            this.usersFilter = response.data;
            /*this.selectedCalendarUser = response.data.data[0]._id;*/
            this.getStatistics();
        });
    },
    computed: {
        ...mapState({
            language: (state) => state.language.language,
            isDarkMode: (state) => state.user.darkMode,
            channels: (state) => [{ _id: "web", name: "Web" }, ...state.channel.channels],
        }),
        moment,
        minDate() {
            return this.startDate ? moment().subtract(45, "day").toISOString() : null;
        },
        calendarUsers() {
            if (Object.keys(this.statistics).length) {
                const c = this.statistics.calendar;
                let userIds = _.flatten(Object.keys(c).map((key) => c[key].map((x) => x.userId)));
                userIds = _.uniq(userIds);
                return this.usersFilter.data.filter((x) => userIds.includes(x._id));
            }
            return [];
        },
        calculateChatbotRate() {
            return Math.ceil((this.statistics.destroyedByChatBot * 100) / this.statistics.totalChatbotConversation);
        },
    },
    watch: {
        language(newValue) {
            log("new language", newValue);
            this.getStatistics();
        },
        calendar(newVal, oldVal) {
            this.calendar = newVal;
            if (newVal) {
                this.renderCalendar();
            }
        },
        selectedCalendarUser(newVal, oldVal) {
            log.debug("selectedCalendarUser changed", newVal);
            this.selectedCalendarUser = newVal;

            this.renderCalendar();
            this.updateCalendarTitle();
        },
        customDateFilter(newVal, oldVal) {
            this.setCustomDateFilter(newVal);
        },
        startDate(newVal, oldVal) {
            this.getStatistics();
        },
        endDate(newVal, oldVal) {
            this.getStatistics();
        },
        selectedUsers(newVal, oldVal) {
            this.getStatistics();
        },
        selectedChannels(newVal, oldVal) {
            this.getStatistics();
        },
        isDarkMode(newValue, oldValue) {
            this.renderBarY(this.statistics.calendar);
            this.renderBar(this.statistics.userChatTimeLine);
            this.beforeCalendar();
            this.renderPie(this.statistics.userChatHistogram);
        },
    },
};
</script>

<style lang="scss" scoped>
.new-theme {
    #report-new {
        $box-colors: [ "#e55699", "#1bc5bd", "#ffa800", "#fef4dd", "#3699ff", "#f64e60", "#8a2be2", "#ff7cc8", "#f4e151",
            "#7994c7", "#008001", "#42eb49", "#45e2ff", "#ba9292", "#f4e151", "#88c779", "#c7af79", "#ac5050", "#7994c7",
            "#008001", "#42eb49" ];

        .box.no-shadow {
            box-shadow: none;
            cursor: auto;

            &:hover {
                box-shadow: none;
            }
        }

        .box.yes-hover {
            cursor: pointer;

            &:hover {
                background-color: #fff4de;
            }
        }

        .box {
            height: 36px;
            border-radius: 6px;
            display: flex;
            background-color: #ffffff;
            padding: 8px;
            align-items: center;
            margin-bottom: 8px;
            /* box-shadow: 0 0 3px #1E1E2D;*/
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                box-shadow: 0 0 6px #00000080;
            }

            &:last-child {
                margin-bottom: 0;
            }

            &::before {
                content: "";
                display: block;
                min-width: 20px;
                height: 20px;
                border-radius: 3px;
                margin-right: 8px;
            }

            p {
                margin: 0;
                font-size: 12px;
                font-weight: 300;
                font-family: Poppins;
                color: #181c32;
                white-space: nowrap;
            }

            p + p {
                font-weight: 700;
                margin-left: auto;
            }
        }

        @for $i from 0 through 18 {
            .box:nth-child(#{$i})::before {
                background-color: unquote(nth($box-colors, $i + 1));
            }
        }

        .custom-card-report {
            min-height: 500px !important;
            background-color: #ffffff;
            padding: 15px 20px;
            border-radius: 6px;
            box-shadow: 0 0 3px #00000080;
        }

        .custom-card-report-overall {
            background-color: #ffffff;
            padding: 15px 20px;
            border-radius: 6px;
        }

        #time-select {
            border: none;
            background-color: #f3f6f9;
            padding: 3px 10px;
            border-radius: 6px;
            font-size: 12px;
            font-family: Poppins;
            font-weight: bolder;
            color: #3699ff;
        }

        .md-chip {
            border-radius: 6px;
            font-weight: 600;
            height: 26px;
            line-height: 26px;
        }

        .pageButtons {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 30px;
            height: 30px;
            border-radius: 6px;
            background-color: #ffffff;
            font-size: 22px;
            border: 1px solid #6c6c6c;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                background-color: #f3f6f9;
            }
        }
    }
}

.dark-mode {
    #report-new {
        .box {
            background-color: #1e1e2d;

            p {
                color: #ffffff !important;
            }
        }

        .box.yes-hover {
            &:hover {
                background-color: #333440;
            }
        }

        .custom-card-report {
            background-color: #1e1e2d !important;
            color: #ffffff !important;
            min-height: 500px !important;

            h5 {
                color: #ffffff !important;
            }
        }
    }
}
</style>
<style lang="scss">
.dark-mode {
    #report-new {
        .form-control {
            background-color: #1e1e2d !important;
            color: #ffffff !important;
            border: transparent;
        }
    }
}
</style>
